import React from "react"

const ViewProfileFieldCell = ({
  value,
  viewProfileCellHandler,
  row: {
    original: { id }
  }
}) => {
  // viewProfileCellHandler is a function that returns a React component
  return viewProfileCellHandler ? viewProfileCellHandler(id, value) : value
}

export default ViewProfileFieldCell
